import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faInfoCircle as faInfoCircleDuotone,
  faQuestionCircle as faQuestionCircleDuotone
} from "@fortawesome/pro-duotone-svg-icons";
import {
  faCaretLeft,
  faCaretRight,
  faCheckCircle,
  faDownload,
  faEnvelope,
  faExclamationTriangle,
  faFolderOpen,
  faInfoCircle,
  faLayerGroup,
  faMinusSquare,
  faPaperclip,
  faPencil,
  faPlusSquare,
  faPrint,
  faQuestionCircle,
  faShareAlt,
  faShareSquare,
  faSmile,
  faTimes as faTimesLight,
  faTrashAlt as faTrashAltLight
} from "@fortawesome/pro-light-svg-icons";
import {
  faBan,
  faBars,
  faCheck,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faExclamationCircle,
  faExternalLink,
  faFileArchive,
  faFileCsv,
  faHistory,
  faHome,
  faInfo,
  faLink,
  faListOl,
  faMapMarker,
  faMinus,
  faMinusSquare as faMinusSquareRegular,
  faPlus,
  faPlusSquare as faPlusSquareRegular,
  faQuestionCircle as faQuestionCircleRegular,
  faSearch,
  faSortDown,
  faSortUp,
  faTimes
} from "@fortawesome/pro-regular-svg-icons";
import {
  faCaretDown,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronLeft as faChevronLeftSolid,
  faChevronRight as faChevronRightSolid,
  faCircle,
  faClock,
  faEdit,
  faExclamationTriangle as faExclamationTriangleSolid,
  faEye,
  faInfoCircle as faInfoCircleSolid,
  faListAlt,
  faLock,
  faRss,
  faTimesCircle,
  faTrashAlt,
  faUserShield
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import { color, space } from "styled-system";

// Initialize fontawesome icons
library.add(
  faBan,
  faBars,
  faCaretLeft,
  faCaretRight,
  faCaretDown,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronDown,
  faChevronLeft,
  faChevronLeftSolid,
  faChevronRight,
  faChevronRightSolid,
  faChevronUp,
  faCircle,
  faClock,
  faDownload,
  faEdit,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faExclamationTriangleSolid,
  faExternalLink,
  faEye,
  faFileArchive,
  faFileCsv,
  faFolderOpen,
  faHistory,
  faHome,
  faInfo,
  faInfoCircle,
  faInfoCircleDuotone,
  faInfoCircleSolid,
  faLayerGroup,
  faLink,
  faListAlt,
  faListOl,
  faLock,
  faMapMarker,
  faMinus,
  faMinusSquare,
  faMinusSquareRegular,
  faPaperclip,
  faPencil,
  faPlus,
  faPlusSquare,
  faPlusSquareRegular,
  faPrint,
  faQuestionCircle,
  faQuestionCircleDuotone,
  faQuestionCircleRegular,
  faRss,
  faSearch,
  faShareAlt,
  faShareSquare,
  faSmile,
  faSortDown,
  faSortUp,
  faTimes,
  faTimesCircle,
  faTimesLight,
  faTrashAlt,
  faTrashAltLight,
  faUserShield
);

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon).attrs(props => ({
  focusable: "false",
  style: props.style
}))`
  ${space};
  ${color};
`;

export const DuoToneFontAwesomeIcon = styled(StyledFontAwesomeIcon)`
  --fa-primary-color: ${props => props.primaryColor};
  --fa-secondary-color: ${props => props.secondaryColor};
  --fa-secondary-opacity: 1;
`;

StyledFontAwesomeIcon.defaultProps = {
  mr: 1,
  ml: 1
};

export const IconPositionerUpperRight = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  ${space};
`;
